import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueMeta from 'vue-meta';


Vue.config.productionTip = true;

Vue.use(VueMeta);

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});
